import { render, staticRenderFns } from "./clientsCompany.vue?vue&type=template&id=5d3c8756&scoped=true&"
import script from "./clientsCompany.vue?vue&type=script&lang=js&"
export * from "./clientsCompany.vue?vue&type=script&lang=js&"
import style0 from "./clientsCompany.vue?vue&type=style&index=0&id=5d3c8756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c8756",
  null
  
)

export default component.exports